import DateFilterCommand from "@/pages/(app)/returns/list/components/commands/date-filter.command";
import StringArrayFilterCommand from "@/pages/(app)/returns/list/components/commands/string-array-filter-command";
import type {
  DateFrontFilterValue,
  StringFrontFilterValue,
} from "@/pages/(app)/returns/providers/return-requests-filters.provider";
import { useReturnRequestsFilters } from "@/pages/(app)/returns/providers/use-return-requests-filters";
import {
  DateFilterName,
  FilterName,
  StringFilterName,
} from "../../utils/types";

interface FiltersCommandProps {
  filterDefinitionKey: FilterName;
}

export default function FiltersCommand({
  filterDefinitionKey,
}: FiltersCommandProps) {
  const { filtersDefinition, filters } = useReturnRequestsFilters();

  const filterDefinition = filtersDefinition.get(filterDefinitionKey);
  const filter = filters.get(filterDefinitionKey);

  if (!filterDefinition) return null;

  if (filterDefinition.type === "string") {
    if (filterDefinition.isMultiSelect) {
      return (
        <StringArrayFilterCommand
          filterDefinition={filterDefinition}
          filterKey={filterDefinitionKey as StringFilterName}
          filter={filter as StringFrontFilterValue}
        />
      );
    }
  }
  if (filterDefinition.type === "date") {
    return (
      <DateFilterCommand
        filterDefinition={filterDefinition}
        filter={filter as DateFrontFilterValue}
        filterKey={filterDefinitionKey as DateFilterName}
      />
    );
  }
}
